var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -8,
    y: -8,
    width: 86,
    height: 86
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_2122_891_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 16,
    transform: "matrix(-1 0 0 1 70 0)",
    fill: "#F59E0B",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 15.5,
    transform: "matrix(-1 0 0 1 69 0)",
    stroke: "#F59E0B",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2122_891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5781 34.7521V23.7982C17.5781 21.4414 19.4887 19.5308 21.8455 19.5308H48.1535C50.5103 19.5308 52.4209 21.4414 52.4209 23.7982V41.5154L17.5781 34.7521Z",
    fill: "#E49824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8993 17.5273H31.2563C29.4455 17.5273 27.9775 18.9953 27.9775 20.8061V40.2399C27.9775 42.0507 29.4455 43.5186 31.2563 43.5186H45.8993C47.7101 43.5186 49.1781 42.0507 49.1781 40.2399V20.8061C49.1781 18.9953 47.7101 17.5273 45.8993 17.5273Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6639 22.5322H26.0209C24.2101 22.5322 22.7422 24.0002 22.7422 25.811V45.2448C22.7422 47.0556 24.2102 48.5236 26.0209 48.5236H40.6639C42.4748 48.5236 43.9427 47.0556 43.9427 45.2448V25.811C43.9427 24.0002 42.4748 22.5322 40.6639 22.5322Z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4209 37.2515V48.2054C52.4209 50.5622 50.5103 52.4728 48.1535 52.4728H21.8455C19.4887 52.4728 17.5781 50.5622 17.5781 48.2054V30.4881C17.5781 28.1313 19.4887 26.2207 21.8455 26.2207H30.2167C31.6541 26.2207 32.9949 26.9443 33.7838 28.1458C35.0698 30.0554 36.5025 33.1707 39.2638 32.984H48.1534C50.5103 32.9841 52.4209 34.8946 52.4209 37.2515Z",
    fill: "#E7A52E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3197 52.4723H21.8457C19.489 52.4723 17.5781 50.5614 17.5781 48.2047V30.4878C17.5781 28.1311 19.489 26.2202 21.8457 26.2202H25.3197C22.9629 26.2202 21.0521 28.1311 21.0521 30.4878V48.2047C21.0521 50.5613 22.963 52.4723 25.3197 52.4723Z",
    fill: "#E49824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9482 23.7985C52.9482 21.592 51.4419 19.6814 49.3282 19.1502C48.695 17.835 47.3787 17 45.9 17H31.2567C29.8428 17 28.5631 17.7761 27.9044 19.0036H21.8457C19.2017 19.0036 17.0508 21.1546 17.0508 23.7985V48.2054C17.0508 50.8491 19.2016 53 21.8453 53H26.9233C27.2146 53 27.4506 52.7639 27.4506 52.4727C27.4506 52.1814 27.2146 51.9453 26.9233 51.9453H21.8454C19.7832 51.9453 18.1055 50.2676 18.1055 48.2054V30.488C18.1055 28.4259 19.7832 26.7481 21.8454 26.7481H30.2168C31.4807 26.7481 32.6493 27.3788 33.343 28.4354L35.2561 31.3484C36.1453 32.7028 37.6436 33.5115 39.2639 33.5115H48.1535C50.2157 33.5115 51.8934 35.1892 51.8934 37.2514V48.2054C51.8934 50.2676 50.2157 51.9453 48.1535 51.9453H29.0327C28.7414 51.9453 28.5054 52.1814 28.5054 52.4727C28.5054 52.7639 28.7414 53 29.0327 53H48.1535C50.7973 53 52.9481 50.8491 52.9481 48.2054L52.9482 23.7985ZM18.1054 27.4929V23.7985C18.1054 21.7361 19.7833 20.0582 21.8456 20.0582H27.5241C27.4754 20.3026 27.4506 20.5523 27.4506 20.806V22.0044H26.0214C23.9622 22.0044 22.2809 23.6487 22.2183 25.6934H21.8454C20.3342 25.6934 18.9849 26.397 18.1054 27.4929ZM36.1377 30.7695L34.2245 27.8565C33.3354 26.5021 31.8371 25.6934 30.2168 25.6934H23.273C23.335 24.2303 24.5438 23.059 26.0214 23.059H40.6645C42.1817 23.059 43.4159 24.2937 43.4159 25.8112V32.4568H39.2639C38 32.4568 36.8314 31.8261 36.1377 30.7695ZM49.706 32.7163V24.3209C49.706 24.0297 49.47 23.7936 49.1787 23.7936C48.8874 23.7936 48.6513 24.0297 48.6513 24.3209V32.4827C48.4876 32.4657 48.3216 32.4568 48.1535 32.4568H44.4706V25.8112C44.4706 23.7121 42.7632 22.0044 40.6645 22.0044H28.5054V20.806C28.5054 20.4343 28.5779 20.0747 28.7212 19.7364C29.1524 18.7148 30.1477 18.0547 31.2567 18.0547H45.9C47.0386 18.0547 48.0441 18.7394 48.4612 19.7979C48.5873 20.1204 48.6513 20.4596 48.6513 20.8059V22.2607C48.6513 22.5519 48.8874 22.7881 49.1787 22.7881C49.47 22.7881 49.706 22.5519 49.706 22.2607V20.806C49.706 20.6643 49.6973 20.5237 49.6818 20.3841C51.0016 20.9743 51.8934 22.2987 51.8934 23.7986V34.2563C51.3302 33.5543 50.5741 33.0142 49.706 32.7163Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7348 25.7547C41.4776 25.6179 41.1584 25.7157 41.0216 25.9729L39.0903 29.6067L37.7549 27.9447C37.5726 27.7177 37.2406 27.6815 37.0135 27.8639C36.7864 28.0464 36.7503 28.3783 36.9327 28.6053L38.7693 30.891C38.9918 31.1842 39.483 31.137 39.6461 30.8082L41.953 26.4679C42.0897 26.2107 41.9921 25.8914 41.7348 25.7547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6455 36.7686H30.6404C30.9317 36.7686 31.1677 36.5324 31.1677 36.2412C31.1677 35.95 30.9317 35.7139 30.6404 35.7139H21.6455C21.3542 35.7139 21.1182 35.95 21.1182 36.2412C21.1182 36.5324 21.3543 36.7686 21.6455 36.7686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6455 38.7197H30.6404C30.9317 38.7197 31.1677 38.4836 31.1677 38.1924C31.1677 37.9011 30.9317 37.665 30.6404 37.665H21.6455C21.3542 37.665 21.1182 37.9011 21.1182 38.1924C21.1182 38.4836 21.3543 38.7197 21.6455 38.7197Z",
    fill: "black"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 59,
    r: 4,
    fill: "#F59E0B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2122_891_clip_path",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 16,
    transform: "matrix(-1 0 0 1 70 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2122_891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.81ebffcd43ed4c7dad7507c1b0dcee98.svg";
export { ForwardRef as ReactComponent };